/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { AiOutlineCheck } from "react-icons/ai";
import Select from "../common/Select";
import { ranking } from "../../data/Data";
import useAuth from "../../Hooks/useAuth";

const TopCollections = () => {
  const [rankingData, setRankingData] = useState(ranking);
  const { showDummyImage } = useAuth();
  const data = {
    selectName: "Price Range",
    selectOptions: [
      {
        optionName: "High to low",
        optionValue: "htl",
      },
      {
        optionName: "Low to High",
        optionValue: "lth",
      },
    ],
  };
  return (
    <section className="top-collections">
      <div className="container">
        <div className="top-collections-wrapper">
          <h2 className="pageTitle">
            Top Collectio<span>ns</span>
          </h2>
          <Tabs>
            <div className="tab-container">
              <TabList className="tabs-btn">
                <Tab className="tab-btn">7 days</Tab>
                <Tab className="tab-btn">15 days</Tab>
                <Tab className="tab-btn">30 day</Tab>
                <Tab className="tab-btn">45 days</Tab>
              </TabList>
              <div className="tab-select">
                <Select data={data} />
              </div>
            </div>
            <TabPanel>
              <div className="top-coll-table">
                <div id="table">
                  <div className="thead">
                    <div className="tr">
                      <div className="th">#</div>
                      <div className="th">Collections</div>
                      <div className="th">Volume</div>
                      <div className="th">floor Price</div>
                    </div>
                  </div>
                  <div className="tbody">
                    {rankingData.map((ele, i) => {
                      const {
                        rankingImg,
                        UserName,
                        price,
                        priceUsd,
                        floorPrice,
                        floorPriceUsd,
                      } = ele;
                      return (
                        <div key={i} className="tr">
                          <div className="td">{i + 1}</div>
                          <div className="td">
                            <div className="coll-user">
                              <div className="coll-user-img">
                                <img
                                  src={require(`${process.env.REACT_APP_RANKING_IMAGE}${rankingImg}`)}
                                  alt={rankingImg}
                                  onError={(
                                    { currentTarget },
                                    imageSize = "60X60"
                                  ) =>
                                    showDummyImage({ currentTarget }, imageSize)
                                  }
                                />
                                <span>
                                  <AiOutlineCheck />
                                </span>
                              </div>
                              <div className="coll-user-left">
                                <h5>{UserName}</h5>
                                <div className="volume">
                                  <span>{price} ETH</span>
                                  <p>
                                    {priceUsd}
                                    <small className="isDown">- 42.7%</small>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="td">
                            <div className="volume">
                              <span>{price} ETH</span>
                              <p>
                                {priceUsd}
                                <small className="isDown">- 42.7%</small>
                              </p>
                            </div>
                          </div>
                          <div className="td">
                            <div className="price">
                              <small>{floorPrice} ETH</small>
                              <span>{floorPriceUsd}</span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="loadmore">
                  <button>
                    <div>Load more Collections</div>
                  </button>
                </div>
              </div>
            </TabPanel>

            <TabPanel>
              <div className="top-coll-table">
                <div id="table">
                  <div className="thead">
                    <div className="tr">
                      <div className="th">#</div>
                      <div className="th">Collections</div>
                      <div className="th">Volume</div>
                      <div className="th">floor Price</div>
                    </div>
                  </div>
                  <div className="tbody">
                    {rankingData.reverse().map((ele, i) => {
                      const {
                        rankingImg,
                        UserName,
                        price,
                        priceUsd,
                        floorPrice,
                        floorPriceUsd,
                      } = ele;
                      return (
                        <div key={i} className="tr">
                          <div className="td">{i + 1}</div>
                          <div className="td">
                            <div className="coll-user">
                              <div className="coll-user-img">
                                <img
                                  src={require(`${process.env.REACT_APP_RANKING_IMAGE}${rankingImg}`)}
                                  alt={rankingImg}
                                  onError={(
                                    { currentTarget },
                                    imageSize = "60X60"
                                  ) =>
                                    showDummyImage({ currentTarget }, imageSize)
                                  }
                                />
                                <span>
                                  <AiOutlineCheck />
                                </span>
                              </div>
                              <div className="coll-user-left">
                                <h5>{UserName}</h5>
                                <div className="volume">
                                  <span>{price} ETH</span>
                                  <p>
                                    {priceUsd}
                                    <small className="isDown">- 42.7%</small>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="td">
                            <div className="volume">
                              <span>{price} ETH</span>
                              <p>
                                {priceUsd}
                                <small className="isDown">- 42.7%</small>
                              </p>
                            </div>
                          </div>
                          <div className="td">
                            <div className="price">
                              <small>{floorPrice} ETH</small>
                              <span>{floorPriceUsd}</span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="loadmore">
                  <button>Load more Collections</button>
                </div>
              </div>
            </TabPanel>

            <TabPanel>
              <div className="top-coll-table">
                <div id="table">
                  <div className="thead">
                    <div className="tr">
                      <div className="th">#</div>
                      <div className="th">Collections</div>
                      <div className="th">Volume</div>
                      <div className="th">floor Price</div>
                    </div>
                  </div>
                  <div className="tbody">
                    {rankingData.reverse().map((ele, i) => {
                      const {
                        rankingImg,
                        UserName,
                        price,
                        priceUsd,
                        floorPrice,
                        floorPriceUsd,
                      } = ele;
                      return (
                        <div key={i} className="tr">
                          <div className="td">{i + 1}</div>
                          <div className="td">
                            <div className="coll-user">
                              <div className="coll-user-img">
                                <img
                                  src={require(`${process.env.REACT_APP_RANKING_IMAGE}${rankingImg}`)}
                                  alt={rankingImg}
                                  onError={(
                                    { currentTarget },
                                    imageSize = "60X60"
                                  ) =>
                                    showDummyImage({ currentTarget }, imageSize)
                                  }
                                />
                                <span>
                                  <AiOutlineCheck />
                                </span>
                              </div>
                              <div className="coll-user-left">
                                <h5>{UserName}</h5>
                                <div className="volume">
                                  <span>{price} ETH</span>
                                  <p>
                                    {priceUsd}
                                    <small className="isDown">- 42.7%</small>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="td">
                            <div className="volume">
                              <span>{price} ETH</span>
                              <p>
                                {priceUsd}
                                <small className="isDown">- 42.7%</small>
                              </p>
                            </div>
                          </div>
                          <div className="td">
                            <div className="price">
                              <small>{floorPrice} ETH</small>
                              <span>{floorPriceUsd}</span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="loadmore">
                  <button>Load more Collections</button>
                </div>
              </div>
            </TabPanel>

            <TabPanel>
              <div className="top-coll-table">
                <div id="table">
                  <div className="thead">
                    <div className="tr">
                      <div className="th">#</div>
                      <div className="th">Collections</div>
                      <div className="th">Volume</div>
                      <div className="th">floor Price</div>
                    </div>
                  </div>
                  <div className="tbody">
                    {rankingData.reverse().map((ele, i) => {
                      const {
                        rankingImg,
                        UserName,
                        price,
                        priceUsd,
                        floorPrice,
                        floorPriceUsd,
                      } = ele;
                      return (
                        <div key={i} className="tr">
                          <div className="td">{i + 1}</div>
                          <div className="td">
                            <div className="coll-user">
                              <div className="coll-user-img">
                                <img
                                  src={require(`${process.env.REACT_APP_RANKING_IMAGE}${rankingImg}`)}
                                  alt={rankingImg}
                                  onError={(
                                    { currentTarget },
                                    imageSize = "60X60"
                                  ) =>
                                    showDummyImage({ currentTarget }, imageSize)
                                  }
                                />
                                <span>
                                  <AiOutlineCheck />
                                </span>
                              </div>
                              <div className="coll-user-left">
                                <h5>{UserName}</h5>
                                <div className="volume">
                                  <span>{price} ETH</span>
                                  <p>
                                    {priceUsd}
                                    <small className="isDown">- 42.7%</small>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="td">
                            <div className="volume">
                              <span>{price} ETH</span>
                              <p>
                                {priceUsd}
                                <small className="isDown">- 42.7%</small>
                              </p>
                            </div>
                          </div>
                          <div className="td">
                            <div className="price">
                              <small>{floorPrice} ETH</small>
                              <span>{floorPriceUsd}</span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="loadmore">
                  <button>Load more Collections</button>
                </div>
              </div>
            </TabPanel>
          </Tabs>
        </div>
      </div>
    </section>
  );
};

export default TopCollections;
